<mat-form-field>
  <mat-label>
    <ng-content select="app-select-label"></ng-content>
  </mat-label>
  <mat-select (valueChange)="change($event)"
    [compareWith]="compareWith"
    [formControl]="control"
    [required]="required"
    [multiple]="multiple">
    <div class="sticky">
      @if (showSelectAll) {
        <app-select-all></app-select-all>
      }
      <app-select-search></app-select-search>
    </div>

    @for (option of options; track option) {
      <mat-option [value]="option.value" [disabled]="option.disabled">
        {{ option.label }}
      </mat-option>
    }
  </mat-select>
  <mat-error>
    <ng-content select="mat-error"></ng-content>
  </mat-error>
</mat-form-field>
